import { IDjangoApi1License } from '../../tn.common';

export function hasBeenPaid(
    licenses: IDjangoApi1License[],
    key: string
): IDjangoApi1License[] {
    return licenses.filter((license) => {
        if (key !== 'app' && key !== 'web') return true;
        const right = license.fontRights[key];
        return right && !!right.end;
    });
}
